import React from 'react';
import SliderCard, { SlidesType } from '@/page-components/Home/Slider/SliderCard/SliderCard';
import PostCard, { PostType } from '@/page-components/Blog/PostCard/PostCard';
import { PageSections } from './sections';

export const getSectionChildren = (
  name: PageSections,
  props: any,
  fallback?: React.ReactNode,
): React.ReactNode => {
  switch (name) {
    case PageSections.SliderSection:
      return props.data?.slides?.map((slide: SlidesType) => (
        <SliderCard
          key={slide.id}
          data={slide}
        />
      ));

    case PageSections.SliderDynamicCards:
      return props?.post?.map((post: PostType) => (
        <PostCard
          key={post.id}
          post={post}
          isSliderCard
        />
      ));

    default:
      return fallback ?? null;
  }
};
